import { ReactNode } from "react";
import "./ButtonLargeSpecialBlock.scss";
import { ButtonLargeSpecialBlockProps } from "/Models/Generated/ButtonLargeSpecialBlockProps";
import classNames from "classnames";

export enum ButtonLargeSpecialTheme {
  Default = 1,
  Pop = 2,
}

interface Props extends ButtonLargeSpecialBlockProps {
  icon?: ReactNode;
  theme?: ButtonLargeSpecialTheme;
  notFullWidth?: boolean;
}

const ButtonLargeSpecialBlock = ({
  iconHref,
  link,
  icon,
  theme,
  notFullWidth,
}: Props) => (
  <a
    href={link?.href}
    className={classNames("button-large-special-block", {
      "button-large-special-block--theme-pop":
        theme === ButtonLargeSpecialTheme.Pop,
      "button-large-special-block--not-full-width": notFullWidth,
    })}
  >
    <div className="button-large-special-block__icon">
      {iconHref && <img src={iconHref} alt="" />}
      {!iconHref && !!icon && icon}
    </div>
    <div className="button-large-special-block__link">
      <span>{link?.text}</span>
    </div>
  </a>
);

export default ButtonLargeSpecialBlock;
